module.exports = __webpack_public_path__ + "assets/excel.a49119e1.svg";